export const ROWS_PER_PAGE = [5, 10, 15, 25, 50, 100];
